export default httpClient => ({

  getData(groupId) {
    return httpClient.get(`/v3/academic/course/group/${groupId}/data`);
  },

  putData(groupId, data) {
    return httpClient.put(`/v3/academic/course/group/${groupId}/data`, data);
  }

})